(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/button/button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/button/button.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.button = svs.tur.payfooter.button || {};
class Button extends svs.tur.Base {
  constructor(options) {
    super(options);
    this.log = new svs.core.log.Logger('payfooter:button');
    this.setOptions();
    this.createButton();
  }
  addEventHandler(eh) {
    this.eventHandler = eh;
  }
  setOptions() {
    this.options = {
      focus: this.focus || false,
      transparent: this.transparent || false,
      inverted: this.inverted || false,
      title: this.title,
      block: true,
      id: this.id,
      className: this.className
    };
  }
  createButton() {
    this.$btn = this.createElement('button');
    const _btn = svs.ui.button.partials.button(this.options);
    this.$btn.innerHTML = _btn;
    this.$btn = this.$btn.firstChild;
    this.amount = new svs.tur.payfooter.Amount({
      title: this.title,
      titleDisabled: this.titleDisabled
    });
    if (this.amount.enabled) {
      this.$btn.innerHTML = '';
      this.$btn.appendChild(this.amount.render());
    }
    this.$btn.addEventListener('click', () => {
      this.callback();
    });
    this.$el.appendChild(this.$btn);
    if (!this.visible) {
      this.hide(false);
    }
  }
  disable() {
    this.$btn.disabled = true;
  }
  enable() {
    this.$btn.disabled = false;
  }
  show() {
    let animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.$el.style.display = 'block';
    if (animate) {
      gsap.fromTo(this.$el, {
        height: 0,
        opacity: 0
      }, {
        height: 'auto',
        opacity: 1,
        duration: 0.2,
        clearProps: 'all'
      });
    }
    this.isVisible = true;
  }
  hide() {
    let animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (animate) {
      gsap.to(this.$el, {
        height: 0,
        opacity: 0,
        duration: 0.1,
        onComplete: () => {
          this.$el.style.display = 'none';
        }
      });
    } else {
      this.$el.style.display = 'none';
    }
    this.isVisible = false;
  }
  render() {
    return this.$el;
  }
  classNames() {
    return ['payfooter-button'];
  }
}
svs.tur.payfooter.button.Default = Button;

 })(window);